import { useEffect, useState } from 'react';
import { apiRequests } from '../../shared/api/apiRequests';
import { Link, useNavigate } from 'react-router-dom';
import { Delete } from '../../features/DeleteEntity/index.js';
import { toast } from 'react-toastify';
import './Team.css';

const TeamStructuresPage = () => {
  const [data, setData] = useState({ items: [], totalCount: 0 });
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    setLoading(true);
    apiRequests.team.getStructures(50, 0).then((res) => {
      setData(res);
      setLoading(false);
    }).catch(() => {
      toast.error('Ошибка загрузки');
      setLoading(false);
    });
  };

  const handleDelete = (id) => {
    apiRequests.team.deleteStructure(id).then(() => {
      toast.success('Структура удалена');
      setData((prev) => ({
        totalCount: prev.totalCount - 1,
        items: prev.items.filter((i) => i.id !== id),
      }));
    }).catch(() => {
      toast.error('Ошибка удаления');
    });
  };

  if (loading) {
    return <div className="team-loading">Загрузка...</div>;
  }

  return (
    <div className="team-page">
      <div className="team-header">
        <div>
          <h1 className="team-title">Структуры команды</h1>
          <p className="team-subtitle">Организационные структуры и группы</p>
        </div>
        <Link to="/team-structures/create">
          <button className="team-add-btn">+ Добавить структуру</button>
        </Link>
      </div>

      <div className="team-list">
        {data.items?.length === 0 ? (
          <div className="team-empty">Нет структур. Создайте первую структуру.</div>
        ) : (
          data.items?.map((item) => (
            <div key={item.id} className="team-item">
              <div className="team-item-info">
                <span className="team-item-name">{item.title}</span>
                {item.groups?.length > 0 && (
                  <span className="team-item-count">{item.groups.length} групп</span>
                )}
              </div>
              <div className="team-item-actions">
                <Link to={`/team-structures/${item.id}`} className="team-btn-view">
                  Открыть
                </Link>
                <Link to={`/team-structures/${item.id}/edit`} className="team-btn-edit">
                  Изменить
                </Link>
                <Delete onConfirm={() => handleDelete(item.id)} />
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default TeamStructuresPage;
